export const MFA_COPY = {
  title: 'Check your email',
  subtitlePrefix: 'Enter the 6-digit code we sent to',
  subtitleFallbackEmail: 'your email',
  otpLabel: 'Verification code',
  otpPlaceholder: 'Enter 6-digit code',
  verifyButton: 'Verify and sign in',
  resendPrompt: "Didn't receive the code?",
  resendAction: 'Resend code',
  resendCountdown: (seconds) => `Resend code in ${seconds}s`,
  backToSignIn: 'Back to sign in',
  resendSuccessMessage: 'A new verification code has been sent.',
  invalidChallengeMessage: 'Invalid or expired MFA challenge.',
};

export const MFA_UI = {
  otpLength: 6,
  resendCooldownSeconds: 60,
};
